export const SAVE_SEARCH_INSTANCES = '/user/profile/save-search-instances';
